// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeaderCOD_header__1T4JK","title":"SubHeaderCOD_title__10WVx","small":"SubHeaderCOD_small__3mi-X","btnContainer":"SubHeaderCOD_btnContainer__1WKv8"};